import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowBendDownRight.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...e, weights: a }));
r.displayName = "ArrowBendDownRightIcon";
const w = r;
export {
  w as ArrowBendDownRight,
  r as ArrowBendDownRightIcon
};
